





















































import { Prop, Component, Vue, Watch, Emit } from 'vue-property-decorator';
import { FormItem, Option, Select } from 'element-ui';
import NullableNumberInput from '@/components/element-ui/NullableNumberInput.vue';
// Types
import { RequestedContainerInput } from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
// Contants
import { containerSizes } from '@/constants/containerSize';

@Component({
  components: {
    'el-form-item': FormItem,
    'nullable-number-input': NullableNumberInput,
    'el-option': Option,
    'el-select': Select
  }
})
export default class ContainerDetails extends Vue {
  @Prop() public container!: RequestedContainerInput;
  @Prop({ required: true }) public index!: number;
  @Prop({ default: false }) public readOnly!: boolean;
  public editableContainer: RequestedContainerInput = { ...this.container };

  public containerOptions(): SelectOption<string>[] {
    return containerSizes.map((size) => {
      return { ...size, label: this.$t(`container.sizes.${size.value}`).toString() };
    });
  }

  emitRemoveContainer() {
    this.$emit('removeContainer');
  }

  @Watch('editableContainer', { deep: true })
  emitContainerDetails() {
    this.$emit('editContainer', this.editableContainer);
  }
}
